import { Pdc } from '@per-diem-calculator/vanilla';

const container = document.querySelector('#perDiemCalc');

const pdc = new Pdc(container, {
    expense: {
        headingPrint: `Per Diem Report`,
        bodyPrint: `Generated by <a href="https://perdiemcalc.org">https://perdiemcalc.org</a>`,
    },
});

pdc.addEventListener('expenseUpdate', e => {
    const { expenses, rates } = e.detail;
    console.table(expenses);
    console.table(rates);
});
